<ng-template #template>
    <div class="downloader-head">
        <h4 class="downloader-head__title">
            {{ 'patient-details.preparing-for-download' | translate }}
        </h4>
        <span class="downloader-head__x" role="button" (click)="close()">
            <img src="/assets/icons/close-gray.svg">
        </span>
    </div>
    <div class="downloader-body">
        <div *ngFor="let item of ticks">
            <app-file-downloader-row [data]="item"></app-file-downloader-row>
        </div>
    </div>
</ng-template>